import mutate from 'js-core/js/apollo/mutations/mutate';
import invalidateQuery from 'js-core/js/apollo/mutations/invalidateQuery';

import CreateUserMutation from 'gql/mutations/User/CreateUser.gql';
import UpdateUserMutation from 'gql/mutations/User/UpdateUser.gql';
import DeleteUserMutation from 'gql/mutations/User/DeleteUser.gql';

export default class{

    static create(input) {

        return mutate(CreateUserMutation, { input }, store => {

            invalidateQuery(store, 'allUsers');
        });
    }

    static update(input) {

        return mutate(UpdateUserMutation, { input }, store => {

            invalidateQuery(store, 'allUsers');
        });
    }

    static delete(id) {

        return mutate(DeleteUserMutation, { id }, store => {

            invalidateQuery(store, 'allUsers');
        });
    }
}
